export class CreateApplicationPeopleOfInterestRcConstants {
    // Controls
    static TRANSFEROR_FORM_CONTROL_NAME = "transferor";
    static TRANSFEREE_FORM_CONTROL_NAME = "transferee";
    static CONVEYANCER_FORM_CONTROL_NAME = "conveyancer";
    // Labels
    static TRANSFEROR_LABEL = "Transferor";
    static TRANSFEREE_LABEL = "Transferee";
    static CONVEYANCER_LABEL = "Conveyancer";
    static COPY_APPLICANT_TO_TRANSFEREE_LABEL = "Copy Applicant To Transferee";
    static COPY_APPLICANT_TO_TRANSFEREE_FORM_CONTROL_NAME = "copyApplicantToTransferee";
}
